import * as React from 'react';
import { CodeBlockWrapper, CodeBlockWrapperProps } from './CodeBlock_SC';

interface Props extends CodeBlockWrapperProps {
  children?: React.ReactNode;
  /**
   * A pre-formatted string of text. Equivalent to passing the text as `children` as `<pre>{code}</pre>`.
   */
  code?: string;
  /**
   * Only applies if `code` is provided. Equivalent to wrapping an the text in a `<code>` element.
   */
  monospace?: boolean;
}

export const CodeBlock: React.FC<Props> = (props) => {
  const { code: codeInput, monospace = false, ...wrapperProps } = props;
  const code = monospace ? <code style={{ fontSize: 14 }}>{codeInput}</code> : codeInput;

  return (
    <CodeBlockWrapper {...wrapperProps}>
      {code ? <pre style={{ margin: 0, whiteSpace: 'break-spaces' }}>{code}</pre> : null}
      {props.children}
    </CodeBlockWrapper>
  );
};
